import React, { useRef } from 'react'
import SwiperCore, { Navigation } from "swiper"
import style from '../../../styles/mystyle.module.css'
import CardsDoctor from './CardsDoctor'
import { Tabs, Tab } from "react-tabs-scrollable";
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import "react-tabs-scrollable/dist/rts.css";
import NearestEntities from './NearestEntities'
import GeoLocation from './GeoLocation';
import { getCookieValue } from '../../helpers/helpers';
import OfferEntiities from './OfferEntiities';
import ShippingOffers from './ShippingOffers';
// import {buidlObject} from '../../helpers/helpers'
SwiperCore.use([Navigation])
function MedicalCard({ entityId, statusIds, days, isInSearchPage, foodSearchLst, entityTypes }) {
  const { locale, query } = useRouter()
  const myRef = useRef(null)
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = React.useState(0);

  const handleClick = (event, category) => {
    setActiveTab(category);

  }
  const [currentLocation, setCurrentLocation] = React.useState()
  React.useEffect(() => {
    if (getCookieValue("location")) {
      setCurrentLocation(getCookieValue("location"))
    }
    setActiveTab(0)
  }, [query])
  return (
    <div className={style.SectionContainer} ref={myRef} id="ref">
      <div className={style.allcard}  >

        <Tabs
          activeTab={activeTab}
          onTabClick={(event, newVal) => handleClick(event, newVal)}
          hideNavBtnsOnMobile={true}
          isRTL={locale == "ar" ? true : false}
          rightNavBtnClassName="rtl-btn"
          leftNavBtnClassName="ltr-btn"
          tabsContainerClassName="justify-center"
          tabsUpperContainerClassName="justify-center"
          style={{ justifyContent: "center" }}
          className={"justify-center"}
        >
          <Tab name="all" className="test" index={0} key={0} style={{ display: "flex" }} aria-describedby={"0"}>
            {t("All")}
          </Tab>
          <Tab name="name1" className="test" index={1} key={1} style={{ display: "flex" }}
            aria-describedby={"1"}
          >
            {t("nearest")}
          </Tab>
          <Tab name="name2" className="test" index={2} key={2} style={{ display: "flex" }}
            aria-describedby={"2"}
          >

            {t("offersOfEntities")}
          </Tab>
          {entityTypes.filter(ele => query.entityType.includes(ele.code)).length == 0 ?
            <Tab
              name="name3"
              className="test"
              index={3}
              key={3}
              style={{ display: "flex" }}
              aria-describedby={"3"}
            >
              {t("shippingOffers")}
            </Tab> : ""}
        </Tabs>
        <div className={style.allcard3}>

          {activeTab == 1 ? <>
            <GeoLocation callBackData={(data) => { setCurrentLocation(data) }} />
            {currentLocation ? <NearestEntities showSlider={true} entityId={entityId} callBackData={(data) => (data)} statusIds={statusIds} days={days} isInSearchPage={isInSearchPage} currentLocation={currentLocation} /> : ""}
          </> : ""}

          {activeTab == 2 ? <>

            <OfferEntiities showSlider={true} entityId={entityId} callBackData={(data) => (data)} statusIds={statusIds} days={days} isInSearchPage={isInSearchPage} currentLocation={currentLocation} />
          </> : ""}

          {activeTab == 3 ? <>

            <ShippingOffers showSlider={true} entityId={entityId} callBackData={(data) => (data)} statusIds={statusIds} days={days} isInSearchPage={isInSearchPage} currentLocation={currentLocation} />
          </> : ""}
          {activeTab != 1 && activeTab != 2 && activeTab != 3 ? <CardsDoctor showSlider={true} entityId={entityId} callBackData={(data) => (data)} statusIds={statusIds} days={days} isInSearchPage={isInSearchPage} /> : ""}
        </div>
      </div>
    </div>




  )
}

export default MedicalCard
